import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class data
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.data = {};

/**
 * GET Endpoint `/data/cells`
 * @param {string|number} list_id
 * @param {string} cell_range
 * @param {boolean} show_missing_rows
 * @param {ReachAPI.Security} security
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.data
 */
ReachAPI.data.getCells = function (list_id, cell_range, show_missing_rows, security) {
    var url = ReachAPI.server + '/data/cells/' + list_id + '/' + cell_range;
    var params = {
        show_missing_rows: show_missing_rows ? 'true' : 'false',
        return: 'json',
    };
    var jqPromise;

    // add security data
    params = security.merge(params);

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Data Cells from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Data Cells from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Data Cells',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/data/lists`
 * @param {string|number} list_id
 * @param {ReachAPI.Security} security
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.data
 */
ReachAPI.data.getLists = function (list_id, security) {
    var url = ReachAPI.server + '/data/lists/' + list_id;
    var params = {
        return: 'json',
    };
    var jqPromise;

    // add security data
    params = security.merge(params);

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Data Lists from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Data Lists from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Data Lists',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
